import { getWorkOvertimes, postWorkOvertime, putWorkOvertime } from '../../../Api/services/backoffice';
import weekday from '../../../Utils/Select/optionsLists/weekday';

export const key = 'workOvertime';

const entityName = {
  singular: 'Hora Extra',
  plural: 'Horas Extras',
};

const queries = {
  list: { key, fn: getWorkOvertimes },
  detail: { key },
};

const mutations = {
  create: postWorkOvertime,
  update: putWorkOvertime,
};

const getRegionWeekdayLabel = (value) => weekday.find((el) => el.value === value)?.label ?? value;

const fields = {
  table: [
    { key: 'weekDay', label: 'Dia', render: (value) => getRegionWeekdayLabel(value) },
    { key: 'hour', label: 'Horário', render: (value) => (value ? `${value}:00` : value) },
    { key: 'letter', label: 'Letra SAP' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
